import React from "react";
import { Checkbox, Radio, TableBody, TableRow, TableCell } from "@sumprio/ui";
import "./TableSkeleton.scss";

const SKELETON_ROW_CAP = 25;

const selectionCellStyle: React.CSSProperties = {
  textAlign: "center",
  verticalAlign: "middle",
};

export function listTableSkeletonRowCount(pageSize: number): number {
  return Math.min(Math.max(pageSize, 1), SKELETON_ROW_CAP);
}

export interface TableSkeletonBodyProps {
  dataColumnCount: number;
  checkboxColumn?: boolean;
  radioColumn?: boolean;
  rowCount?: number;
}

function SkeletonRows({
  dataColumnCount,
  checkboxColumn,
  radioColumn,
  rowCount = 8,
}: TableSkeletonBodyProps) {
  return (
    <>
      {Array.from({ length: rowCount }, (_, ri) => (
        <TableRow key={ri} className="table-skeleton__row">
          {checkboxColumn && (
            <TableCell width="1%" className="table-skeleton__cell" style={selectionCellStyle}>
              <Checkbox checked={false} disabled size="sm" onChange={() => {}} />
            </TableCell>
          )}
          {radioColumn && (
            <TableCell width="1%" className="table-skeleton__cell" style={selectionCellStyle}>
              <Radio
                checked={false}
                disabled
                name={`table-skeleton-radio-${ri}`}
                size="sm"
                value={`skeleton-${ri}`}
                onChange={() => {}}
              />
            </TableCell>
          )}
          {Array.from({ length: dataColumnCount }, (_, ci) => (
            <TableCell
              key={ci}
              className="table-skeleton__cell"
              style={{ minWidth: 88, verticalAlign: "middle" }}
            >
              <span
                className="table-skeleton__bar"
                style={{ maxWidth: `${42 + ((ri * 3 + ci * 5) % 48)}%` }}
                aria-hidden
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export function TableSkeletonRows(props: TableSkeletonBodyProps) {
  return <SkeletonRows {...props} />;
}

export default function TableSkeletonBody(props: TableSkeletonBodyProps) {
  return (
    <TableBody>
      <SkeletonRows {...props} />
    </TableBody>
  );
}
